import { createPinia } from "pinia";
import SyncStorage from "./plugins/syncStorage";
import storeReset from "./plugins/storeReset";

const pinia = createPinia();

// Register plugins
pinia.use(({ store }) => SyncStorage(store, {}));
pinia.use(storeReset);

export default pinia;
